import { Article } from "@MeteoApi/models/Article";
import { ArticleService } from "@MeteoApi/services/ArticleService";
import { getArticleDate } from "@Utils/article";
import { useEffect, useState } from "react";

const useArticleDate = () => {
  const [articleDate, setArticleDate] = useState(getArticleDate());

  useEffect(() => {
    const handleHashChange = () => {
      setArticleDate(getArticleDate());
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return articleDate;
};

export const useArticle = () => {
  const articleDate = useArticleDate();
  const [article, setArticle] = useState<Article>();
  const [error, setError] = useState<Error>();

  const removeLoadingState = () => {
    // remove CMS loading state
    const shimmerBox = document.getElementsByClassName("shimmer-box")[0] as
      | HTMLElement
      | undefined;
    shimmerBox?.style.setProperty("display", "none");
  };

  useEffect(() => {
    const promise =
      articleDate === "today"
        ? ArticleService.getLatestArticle()
        : ArticleService.getArticleByDate(articleDate);
    promise
      .then((article: Article) => {
        setArticle(article);
        removeLoadingState();
        return;
      })
      .catch((e: Error) => {
        // eslint-disable-next-line no-console
        console.error(e);
        setError(e);
        removeLoadingState();
      });
  }, [articleDate]);

  return { article, error };
};
